import { render } from "./PreloaderVac.vue?vue&type=template&id=b4bc0b56&lang=true"
import script from "./PreloaderVac.vue?vue&type=script&lang=js"
export * from "./PreloaderVac.vue?vue&type=script&lang=js"

import "./PreloaderVac.vue?vue&type=style&index=0&id=b4bc0b56&lang=scss"

import exportComponent from "C:\\Users\\MrBin\\Desktop\\Front\\vac2\\VAC\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__